<template>
  <v-row>
    <v-col cols="12" lg="12">
      <SumarryReports isActive="onhand"></SumarryReports>
    </v-col>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  On-hand List
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <v-btn color="primary" class="ml-auto">
                  <download-csv :data="exportData" :name="`${fileName}.csv`">
                    <v-icon dense>mdi-download</v-icon>
                    Export
                  </download-csv>
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.destination`]="{ item }">
            {{ item.destination ? item.destination : "Hub" }}
          </template>

          <template v-slot:[`item.modelId`]="{ item }">
            {{ filterModels(item.modelId)[0].name }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <!-- <a @click="viewDrawDetail(item)">{{ item.name }}</a> -->
            <v-btn small color="primary" dark @click="editDrawDetail(item)">
              Check Status</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import SumarryReports from "./components/dashboard_components/SumarryReports.vue";
export default {
  name: "OnhandList",
  components: {
    SumarryReports,
  },
  data() {
    return {
      exportData: [],
      fileName: "",
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        //  SN | Type | Model | Date/Time Received from WH | Released by | Destination | Date/Time Received

        headers: [
          {
            text: "SN",
            sortable: false,
            value: "serialNumber",
          },
          { text: "Type", value: "type" },
          { text: "Model", value: "model" },
          { text: "Received by", value: "receivedBy" },
          { text: "Destination", value: "destination" },
          {
            text: "Date/Time Received",
            value: "createdDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
        ],
        data: [],
      },

      brands: [],
      models: [],
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/dashboard/inventory?status=ADDED")
        .then((response) => {
          const newArr = response.data.data.devices;
          this.table.data = newArr;

          let exportData = newArr.map((item) => {
            return {
              SN: item.serialNumber,
              Type: item.type,
              Model: item.model,
              "Received by": item.receivedBy,
              Destination: (item.destination) ? item.destination : "Hub",
              "Date/Time Received": moment(item.createdDate).format(
                "MMM DD, YYYY h:mm:ss A"
              ),
              // SKU: item.name,
              // Amount: item.amount,
            };
          });
          this.fileName = "onhand_list";
          this.exportData = exportData;

          const result = newArr.filter((o) =>
            Object.keys(this.table.headers).every((k) => this.table.headers[k] === o[k])
          );
          console.log(result)
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
